import { render, staticRenderFns } from "./BlockPriceCategoryForm.vue?vue&type=template&id=12f844fc&scoped=true"
import script from "./BlockPriceCategoryForm.vue?vue&type=script&lang=js"
export * from "./BlockPriceCategoryForm.vue?vue&type=script&lang=js"
import style0 from "./BlockPriceCategoryForm.vue?vue&type=style&index=0&id=12f844fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f844fc",
  null
  
)

export default component.exports